import React from 'react'
import {Button} from '@lazarusai/forms-ui-components'
import '../styles/Footer.css'

export default function Footer(props) {
  return (
    <footer
      className='footer'
      style={
        props.style?.width ?
          {width: props.style.width} :
          {}
      }
    >
      <div />
      <div
        className='footer-content'
        style={
          props.style?.padding ?
          {
            padding: props.style.padding,
          } :
          {}
        }
      >
        {props.onClickBack ?
        <div
          className='btn1-container'
        >
          <Button
            style={{
              backdropFilter: 'initial',
            }}
            text={'Back'}
            onClick={props.onClickBack}
            theme={props.theme}
            width={'14em'}
          />
        </div> :
        <div className='btn1-container'></div>
        }
        <div className='right-container'>
          {props.skip &&
            <span
              className='link-btn'
              id='skip-step'
              onClick={props.skip}
            >
              Skip this step
            </span>
          }
          <Button
            style={{
              backdropFilter: 'initial',
            }}
            text={'Continue'}
            onClick={props.onClickContinue}
            theme={props.theme}
            width={'14em'}
            disabled={props.onClickContinue ? false : true}
          />
        </div>
      </div>
    </footer>
  )
}
